<div class="col">
  <div class="card" style="width: 100%;">
    <div class="card-body">
      <div class="wrapper">
        <img class="card-img-top" src="/assets/images/confirmation.svg" alt="Card image cap">
        <h5 *ngIf="!this.requestCompleted" class="card-title">{{this.lables(this.getPageName()).sending}}</h5>
        <h5 *ngIf="this.requestCompleted && !this.requestFailed" class="card-title">{{this.lables(this.getPageName()).lable}}</h5>
        <div *ngIf="this.requestCompleted && this.requestFailed" class="alert alert-danger" role="alert">
          {{this.requestErrorMessage}}
        </div>
        <button *ngIf="this.requestCompleted && this.requestFailed" (click)="this.moveBack()" class="btn btn-primary doneBtn">{{this.lables(this.getPageName()).backBtn}}</button>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
